/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsCloudWatchLogGroupDetails {
    getFixupPrototypeFunction() { return AwsCloudWatchLogGroupDetails.fixupPrototype; }

    static newInstance(model: Partial<AwsCloudWatchLogGroupDetails>): AwsCloudWatchLogGroupDetails {
        let obj = Object.assign(new AwsCloudWatchLogGroupDetails(), model);
        AwsCloudWatchLogGroupDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsCloudWatchLogGroupDetails>): AwsCloudWatchLogGroupDetails {
        if (!model) return null;
        return AwsCloudWatchLogGroupDetails.newInstance(<AwsCloudWatchLogGroupDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsCloudWatchLogGroupDetails) {
        if (!obj) return;

        models.AwsCloudWatchLogGroupDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsCloudWatchLogGroupDetails): boolean {
        Object.setPrototypeOf(obj, AwsCloudWatchLogGroupDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the CloudWatch log group
     */
    name: string;

    /**
     * ARN of the CloudWatch log group
     */
    arn: string;

}
